export const features = [
  {
    id: 1,
    title: "Automate salary calculations",
    description:
      "Eliminate manual entry errors with our proprietary calculation engine that scales from 1 to 100 employees.",
    icon: "calculator",
    label: "Core Engine",
    backgroundColor: "#1A1A1E",
    textColor: "#FFFFFF",
    gridPosition: "top-left",
  },
  {
    id: 2,
    title: "Tax deductions",
    description:
      "Real-time tax tracking and automatic filing preparations for all jurisdictions.",
    icon: "percent",
    backgroundColor: "#FFFFFF",
    textColor: "#333333",
    gridPosition: "top-right",
  },
  {
    id: 3,
    title: "Regulatory compliance",
    description:
      "Automated updates ensure you never fall behind on legal requirements.",
    icon: "checkmark",
    backgroundColor: "#FFFFFF",
    textColor: "#333333",
    gridPosition: "bottom-left",
  },
  {
    id: 4,
    title: "Centralized Reporting",
    description:
      "Access all your payroll data in a single, high-fidelity dashboard with exportable reports for accounting.",
    icon: "dashboard",
    backgroundColor: "var(--color-primary)",
    textColor: "#FFFFFF",
    gridPosition: "bottom-right",
  },
];
